import { JsonObject, JsonProperty } from 'json2typescript'
import Enclosure from './Enclosure'
import Insurer from './Insurer'
import Model from './Model'
import NCDStepBackRule from './NCDStepBackRule'
import SchemeDocument from './SchemeDocument'
import SchemeTier from './SchemeTier'

@JsonObject('Scheme')
export default class Scheme extends Model {
  @JsonProperty('code', String)
  code: string

  @JsonProperty('name', String)
  name: string

  @JsonProperty('isPayMonthly', Boolean)
  isPayMonthly: boolean

  @JsonProperty('schemeVariant', String, true)
  schemeVariant?: string

  @JsonProperty('canxPortalEffectiveTimeNow', Boolean)
  canxPortalEffectiveTimeNow: boolean

  @JsonProperty('enclosures', [Enclosure])
  enclosures: Enclosure[]

  @JsonProperty('schemeDocuments', [SchemeDocument])
  schemeDocuments: SchemeDocument[]

  @JsonProperty('insurer', Insurer)
  insurer: Insurer

  @JsonProperty('protectedNCDStepBackRules', [NCDStepBackRule])
  protectedNCDStepBackRules: NCDStepBackRule[]

  @JsonProperty('unprotectedNCDStepBackRules', [NCDStepBackRule])
  unprotectedNCDStepBackRules: NCDStepBackRule[]

  @JsonProperty('schemeTier', SchemeTier)
  schemeTier: SchemeTier

  constructor(
    id = 0,
    code = '',
    name = '',
    schemeVariant?: string,
    isPayMonthly = false,
    canxPortalEffectiveTimeNow = false,
    enclosures: Enclosure[] = [],
    schemeDocuments: SchemeDocument[] = [],
    insurer: Insurer = new Insurer(),
    protectedNCDStepBackRules: NCDStepBackRule[] = [],
    unprotectedNCDStepBackRules: NCDStepBackRule[] = [],
    schemeTier: SchemeTier = new SchemeTier(),
  ) {
    super(id)
    this.code = code
    this.name = name
    this.schemeVariant = schemeVariant
    this.isPayMonthly = isPayMonthly
    this.canxPortalEffectiveTimeNow = canxPortalEffectiveTimeNow
    this.enclosures = enclosures
    this.schemeDocuments = schemeDocuments
    this.insurer = insurer
    this.protectedNCDStepBackRules = protectedNCDStepBackRules
    this.unprotectedNCDStepBackRules = unprotectedNCDStepBackRules
    this.schemeTier = schemeTier
  }
}
